import { render, staticRenderFns } from "./CustomTask.vue?vue&type=template&id=25bbd3c2&scoped=true&"
import script from "./CustomTask.vue?vue&type=script&lang=js&"
export * from "./CustomTask.vue?vue&type=script&lang=js&"
import style0 from "./CustomTask.vue?vue&type=style&index=0&id=25bbd3c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bbd3c2",
  null
  
)

export default component.exports